// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2TC-Z","savePackageButton":"ClientWallet_savePackageButton__2cOmG"};